import React from 'react';

import {
  LayoutExtensionContainer,
} from '../../containers/LayoutExtensionContainer/LayoutExtensionContainer';
import { Button, ButtonFit, ButtonIntent } from '../Button/Button';
import { Modal } from '../Modal/Modal';
import { Typography } from '../Typography/Typography';
import styles from './SuccessModal.module.css';

export type Props = {
  buttonText: JSX.Element | string;
  isOpen: boolean;
  message: JSX.Element | string;
  onButtonClick: () => void;
  onClose: () => void;
};

export const SuccessModal = React.memo((props: Props) => {
  const {
    isOpen,
    onClose,
    onButtonClick,
    message,
    buttonText,
  } = props;

  return (
    <LayoutExtensionContainer>
      {({ isMobileLayout }) => (
        <Modal
          isMobileLayout={isMobileLayout}
          isOpen={isOpen}
          onClose={onClose}
          modalContentWrapperClassName={{ base: styles.modalContentWrapper }}
        >
          <div className={styles.modalContent}>
            <div className={styles.message}>
              <Typography variant='body1'>{message}</Typography>
            </div>

            <Button
              className={styles.button}
              onClick={onButtonClick}
              intent={ButtonIntent.primary}
              fit={ButtonFit.Fill}
            >
              {buttonText}
            </Button>
          </div>
        </Modal>
      )}
    </LayoutExtensionContainer>
  );
});

SuccessModal.displayName = 'SuccessModal';
